import { ChangeHighlighter } from '@rd-web-markets/shared/dist/util/ChangeHighlighter';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
import { apiKey, getDefaultConfig } from '@rd-web-markets/shared/dist/util/tinyMceConfig';
import { Editor } from '@tinymce/tinymce-react';
import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
const ProjectReportSlice = _ref => {
  let {
    index,
    slice,
    handleTinyMce,
    handleSliceChange,
    handleSubmit,
    pageAccess,
    isDisabled
  } = _ref;
  const {
    title,
    description,
    tab
  } = slice;
  const canEditTextBody = pageAccess.canEditProjectDetails || tab === 'activity' && pageAccess.canEditProjectActivity;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    as: Row,
    className: "pt-2"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-primary"
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    disabled: !pageAccess.canEditProjectDetails || isDisabled,
    as: Form.Control,
    object: slice,
    onBlur: handleSubmit,
    controlAs: "textarea",
    rows: "2",
    name: "label",
    onChange: e => handleSliceChange(e, index)
  }))), tab === 'narrative' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 2,
      offset: 6
    },
    className: "pb-4 text-end"
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    disabled: !pageAccess.canEditProjectDetails || isDisabled,
    as: Form.Check,
    object: slice,
    name: "include_in_rnd_report",
    onChange: e => handleSliceChange(e, index),
    label: "Include in R&D Report"
  })), /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement("p", null, description))), /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    disabled: !canEditTextBody || isDisabled,
    as: Editor,
    apiKey: apiKey,
    onBlur: handleSubmit,
    onEditorChange: e => handleTinyMce(e, title, index),
    object: slice,
    init: getDefaultConfig({
      stylesFormatterToggleIniitialValue: true,
      modules: {
        styles_formatter: true
      }
    }),
    name: "body"
  }))));
};
export default ProjectReportSlice;